<div class="subscribe-content">
    <span class="sub-title">Go At Your Own Pace</span>
    <h2>Subscribe To Our Newsletter</h2>
    <p>To get daily updates from our side. Subscribe to Sarveksha using your mail</p>
    <form class="newsletter-form">
        <input type="text" class="input-newsletter" placeholder="Enter your email address" name="EMAIL" required autocomplete="off">
        <button type="submit" class="default-btn"><i class="flaticon-user"></i>Subscribe Now<span></span></button>
    </form>
</div>
